import { jsx as r, jsxs as s } from "react/jsx-runtime";
import a from "classnames";
import e from "../../utils/colors.js";
import { b as f } from "../../styled-qu50FBLM.mjs";
import { Svg as d, GElement as t, Circle as x, Path as L } from "./Elements.js";
const j = ({
  className: i = "",
  fill: l = e.green,
  width: m = 25,
  height: n = 25,
  $cssHelper: c = f,
  focusable: o
}) => /* @__PURE__ */ r(
  d,
  {
    className: a({ [i]: !!i }),
    viewBox: `0 0 ${m} ${n}`,
    $cssHelper: c,
    focusable: !!o,
    "aria-hidden": !o,
    children: /* @__PURE__ */ s(t, { children: [
      /* @__PURE__ */ r(x, { cx: "12.5", cy: "12.5", r: "12.5", fill: l }),
      /* @__PURE__ */ r(t, { transform: "matrix(1,0,0,1,6,7)", children: /* @__PURE__ */ r(
        L,
        {
          d: "M5.913,9.31L4.338,11L0,6.345L1.575,4.655L4.338,7.62L11.441,0L13,1.69L5.913,9.31Z",
          fill: e.white,
          fillRule: "nonzero"
        }
      ) })
    ] })
  }
);
export {
  j as default
};
